<app-auth-layout>
  <div class="text-center">
    <h2 class="mb-4 text-xl font-bold text-gray-900 dark:text-white">Forgot your password?</h2>
    <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
      Enter your email address below and we'll send you a link to reset your password.
    </p>
  </div>

  <form (ngSubmit)="onSubmit(forgotPasswordForm)" class="space-y-6" #forgotPasswordForm="ngForm">
    <div>
      <label for="email" class="sr-only">Email Address</label>
      <input
        id="email"
        name="email"
        type="email"
        [(ngModel)]="email"
        autocomplete="email"
        required
        #emailField="ngModel"
        data-cy="page-forgotPassword-input-email"
        class="appearance-none relative block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 placeholder-gray-500 dark:placeholder-gray-400 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-sky-500 focus:border-sky-500 focus:z-10 sm:text-sm"
        placeholder="Email Address"
      />
      <app-form-field-error [errors]="getErrors(emailField)"></app-form-field-error>
    </div>

    @if (message) {
    <div
      data-cy="page-forgotPassword-text-status"
      class="p-3 rounded-md text-center font-medium border"
      [ngClass]="{
        'text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-900 border-green-200 dark:border-green-700':
          !isError,
        'text-red-500 dark:text-red-400 bg-red-50 dark:bg-red-900 border-red-200 dark:border-red-700': isError
      }"
    >
      {{ message }}
    </div>
    }

    <div>
      <button type="submit" [disabled]="isLoading" data-cy="page-forgotPassword-button-sendLink" class="btn-primary group relative w-full flex justify-center">
        @if (isLoading) {
        <app-loading-spinner class="mr-2"></app-loading-spinner>
        }
        <span>Send Reset Link</span>
      </button>
    </div>
  </form>

  <div class="text-center">
    <a routerLink="/login" data-cy="page-forgotPassword-link-backToLogin" class="link"> Back to Login </a>
  </div>
</app-auth-layout>
